import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import QuoteForm from "../components/QuoteForm";
import { SITE } from "../data/site";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="bg-[var(--bg-primary)]">
      <Navbar />

      <section className="pt-36 pb-16 bg-[var(--maroon-950)] text-white relative grain">
        <div className="container-edge relative">
          <div className="overline text-[#D38888]">Get in touch</div>
          <h1 className="font-display text-5xl md:text-7xl mt-5 leading-[1] tracking-tight">
            Let's build the next die.
          </h1>
          <p className="mt-6 max-w-2xl text-[#E8DCC8]/85 text-lg">
            Whether you're spec'ing a new line, replacing worn rollers, or developing a fresh biscuit shape — we'd love to talk.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-edge grid grid-cols-1 lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-4 space-y-8">
            <div>
              <div className="overline">Workshop</div>
              <div className="mt-4 flex gap-4">
                <MapPin size={20} className="text-[var(--maroon-700)] mt-1 shrink-0" />
                <div className="text-[var(--text-primary)]">
                  <div className="font-display text-xl">{SITE.brand}</div>
                  <div className="text-[var(--text-secondary)] mt-1">{SITE.addressLine1}</div>
                  <div className="text-[var(--text-secondary)]">{SITE.addressLine2}</div>
                </div>
              </div>
            </div>

            <div>
              <div className="overline">Phone & WhatsApp</div>
              <div className="mt-4 flex gap-4">
                <Phone size={20} className="text-[var(--maroon-700)] mt-1 shrink-0" />
                <a data-testid="contact-phone" href={`tel:${SITE.phone.replace(/\s+/g, "")}`} className="font-display text-xl text-[var(--maroon-950)] hover:text-[var(--maroon-700)]">
                  {SITE.phone}
                </a>
              </div>
            </div>

            <div>
              <div className="overline">Email</div>
              <div className="mt-4 flex gap-4">
                <Mail size={20} className="text-[var(--maroon-700)] mt-1 shrink-0" />
                <a data-testid="contact-email" href={`mailto:${SITE.email}`} className="font-display text-xl text-[var(--maroon-950)] hover:text-[var(--maroon-700)] break-all">
                  {SITE.email}
                </a>
              </div>
            </div>

            <div>
              <div className="overline">Hours</div>
              <div className="mt-4 flex gap-4">
                <Clock size={20} className="text-[var(--maroon-700)] mt-1 shrink-0" />
                <div className="text-[var(--text-secondary)]">
                  Mon – Sat · 9:30 AM – 6:30 PM<br />
                  Sundays closed
                </div>
              </div>
            </div>

            <div className="bg-[var(--bg-secondary)] border-l-4 border-[var(--maroon-700)] p-5 mt-6">
              <div className="overline">GST · IEC</div>
              <div className="font-mono-accent text-sm mt-2 text-[var(--text-primary)]">{SITE.gst}</div>
              <div className="font-mono-accent text-sm text-[var(--text-primary)]">{SITE.iec}</div>
            </div>
          </aside>

          <div className="lg:col-span-8">
            <div className="overline">Send a message</div>
            <h2 className="font-display text-3xl md:text-4xl mt-4 text-[var(--maroon-950)] leading-tight">
              Tell us about your line, your dough, your shape.
            </h2>
            <div className="mt-10">
              <QuoteForm />
            </div>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="bg-[var(--bg-secondary)]">
        <div className="container-edge py-16">
          <div className="overline">Find us</div>
          <h2 className="font-display text-3xl md:text-4xl mt-4 text-[var(--maroon-950)]">Focal Area, Patiala</h2>
          <div className="mt-8 aspect-[16/7] border border-[var(--border-subtle)] overflow-hidden">
            <iframe
              data-testid="contact-map"
              title="Patiala location"
              src="https://www.google.com/maps?q=Focal+Point+Patiala+Punjab&output=embed"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
